import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🐣',
    title: 'pages.onboarding.levelQuestion.answer1',
    subtitle: 'pages.onboarding.levelQuestion.answer1Subtitle',
    value: 'beginner',
  },

  {
    emoji: '🌱',
    title: 'pages.onboarding.levelQuestion.answer2',
    subtitle: 'pages.onboarding.levelQuestion.answer2Subtitle',
    value: 'elementary',
  },

  {
    emoji: '💬',
    title: 'pages.onboarding.levelQuestion.answer3',
    subtitle: 'pages.onboarding.levelQuestion.answer3Subtitle',
    value: 'intermediate',
  },
  {
    emoji: '🚀',
    title: 'pages.onboarding.levelQuestion.answer4',
    subtitle: 'pages.onboarding.levelQuestion.answer4Subtitle',
    value: 'advanced',
  },
]

export default function LevelQuestionPage() {
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    const selectedLevel = event.currentTarget.value as string

    if (selectedLevel) {
      localStorage.setItem('comfortLevel', selectedLevel)
    }
  }

  return (
    <SingleChoiceQuestionPage
      answers={answers}
      subtitle="pages.onboarding.levelQuestion.subtitle"
      title="pages.onboarding.levelQuestion.title"
      onSubmit={handleSubmit}
    />
  )
}
